module.exports = __webpack_public_path__ + "img/GALLERY-IGNIS-6.9b606024.jpg";